import { SFPermission } from "@robe/core-types";
import { parseQueryParamsObject } from "@robe/core-utils";
import { XcoreCore } from "XcoreCore";

export class RobeSupportFilesPermissions {
  private core: XcoreCore;

  constructor(core: XcoreCore) {
    this.core = core;
  }

  public getEntityPermissions(path: string) {
    return this.core.fetch(`/api/permission/${path}`).then<SFPermission[]>((r) => r.json());
  }

  public makePathPublic(path: string) {
    return this.core.fetch("/api/permission", {
      method: "POST",
      body: JSON.stringify({ type: "public", path }),
    });
  }

  public makePathHidden(path: string) {
    return this.core.fetch("/api/permission", {
      method: "POST",
      body: JSON.stringify({ type: "hidden", path }),
    });
  }

  public addGroupRight(path: string, groupId: number) {
    return this.core.fetch("/api/permission", {
      method: "POST",
      body: JSON.stringify({ groupId, type: "group", path }),
    });
  }

  public removeRight(path: string, rightId: number) {
    return this.core.fetch(`/api/permission/remove${parseQueryParamsObject({ id: rightId })}`, {
      method: "POST",
      body: JSON.stringify({ path }),
    });
  }

  public restoreRight(path: string, permissionId: number) {
    return this.core.fetch("/api/permission/restore/" + permissionId, {
      method: "POST",
      body: JSON.stringify({ path }),
    });
  }
}
